import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as fromGroups from '../../reducers/groups.reducer';
import * as fromRoot from '@app/reducers';
import { Role } from '@app/shared/models/role';
import { Team } from '@app/shared/models/team';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Constant } from 'src/constant';
import { GroupsActions } from '../../actions';

@Component({
  selector: 'app-modal-add-group',
  templateUrl: './modal-add-group.component.html',
  styleUrls: ['./modal-add-group.component.scss']
})
export class ModalAddGroupComponent implements OnDestroy {

  groupCreated$: Observable<boolean>;
  createGroupPending$: Observable<boolean>;
  createGroupError$: Observable<any>;


  subscriptions: Subscription[] = [];
  createGroupForm: FormGroup;
  selectedTeam: Team;
  selectedRole: Role;
  selectionTeamEnabled = true;
  submitted = false;
  teamId: string;

  excludeSCIMPattern = /(?!scim\b)\b\w+/i;

  constructor(
    private store$: Store<fromRoot.State & fromGroups.State>,
    private fb: FormBuilder,
    public ref: DialogRef
  ) {
    this.teamId = this.ref.data.teamId;
    this.groupCreated$ = this.store$.select(fromGroups.getCreateGroupSuccess);
    this.createGroupPending$ = this.store$.select(fromGroups.getCreateGroupPending);
    this.createGroupError$ = this.store$.select(fromGroups.getCreateGroupError);
    this.initGroupCreationForm();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  get f() { return this.createGroupForm.controls; }

  initGroupCreationForm() {
    this.createGroupForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(Constant.regexpGroupName), Validators.pattern(this.excludeSCIMPattern)]],
    });
  }

  createGroup(name: string) {
    this.store$.dispatch(GroupsActions.CreateGroup({ teamId: this.teamId, name }));
    this.subscriptions.push(this.groupCreated$.subscribe(res => {
      if (res) {
        this.store$.dispatch(GroupsActions.LoadGroups({ teamId: this.teamId }));
        this.close();
      }
    }));
  }

  close() {
    this.submitted = false;
    this.createGroupForm.reset();
    this.ref.close();
  }

  onSubmit() {
    this.submitted = true;
    if (this.createGroupForm.valid) {
      this.createGroup(this.createGroupForm.value.name);
    }
  }
}
